import SupportMentorCalendar from 'src/supportPortal/components/common/mentor/mentorCalendar/SupportMentorCalendar'
import { getAllRolesInBoolean } from 'src/mentor/layout/utils'

export default function DoctorBookings() {
  const { isClinicSuccessAdmin, isClinicSuccessManager } = getAllRolesInBoolean()
  return (
    <SupportMentorCalendar
      dontOpenReports
      getSingleMentorApiSignature="/api/secure/cc/support/doctor/by-slug"
      meetingBookApiSignature="/api/secure/cc/support/doctor/meeting/book"
      bookingAllowed={isClinicSuccessAdmin || isClinicSuccessManager}
    />
  )
}
